import { render } from "./CompletedGameView.vue?vue&type=template&id=3d92fbf8"
import script from "./CompletedGameView.vue?vue&type=script&lang=js"
export * from "./CompletedGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__